import DOMPurify from 'dompurify';
export interface SetFieldValue {
  // @ts-ignore
  (field, value): void;
}

export type InputState = 'neutral' | 'valid' | 'invalid';

export function sanitizeHtml(html: string): string {
  let sanitizingOptions = {
    ALLOWED_TAGS: ['strong', 'b', 'i', 'em', 'p', 'br', 'a'],
    ALLOWED_ATTR: ['style', 'class', 'href', 'rel', 'target'],
  };
  return DOMPurify.sanitize(html, sanitizingOptions);
}
